import { useEffect, useRef } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Loader } from '@altermaind/web/ui';
import { AlertBadge } from '@/_shared/components';
import { getEmployeesStatsCall } from '../../state';
import { AddEmployeeChoiceDialog, AddEmployeeFormDialog } from '../AddEmployee';
import { AssignDepartmentDialog } from '../AssignDepartmentDialog';
import { EmployeesList } from '../EmployeesList';
import { NoCompanyData } from '../NoCompanyData';
import { RecapPeople } from '../RecapPeople';
import { UsefulInformation } from '../UsefulInformation';

export const PeopleIntro = () => {
  const tShared = useTranslations();

  const {
    execute: executeGetEmployeesStats,
    loading: loadingGetEmployeesStats,
    error: errorGetEmployeesStats,
    success: successGetEmployeesStats,
    total,
    completed,
    invalid,
  } = getEmployeesStatsCall.hook();

  // Track whether data has ever been loaded successfully to avoid unmounting
  // RecapPeople (and the SendSurvey dialog inside it) during background re-fetches.
  const hasLoadedOnce = useRef(false);
  if (successGetEmployeesStats) {
    hasLoadedOnce.current = true;
  }

  useEffect(() => {
    executeGetEmployeesStats({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!hasLoadedOnce.current && loadingGetEmployeesStats) {
    return (
      <Box mt='s' textAlign='center'>
        <Loader size='s' />
      </Box>
    );
  }

  if (!hasLoadedOnce.current && errorGetEmployeesStats) {
    const message = tShared('errors.genericApiError');
    return <AlertBadge containerProps={{ mt: 's' }} iconName='info' type='error' label={message} />;
  }

  if (
    hasLoadedOnce.current ||
    (successGetEmployeesStats && !loadingGetEmployeesStats && !errorGetEmployeesStats)
  ) {
    return (
      <Box>
        {total === 0 ? (
          <>
            <NoCompanyData />
            <UsefulInformation />
          </>
        ) : (
          <>
            <RecapPeople total={total} completed={completed} invalid={invalid} />
            <EmployeesList />
          </>
        )}
        <AddEmployeeChoiceDialog />
        <AddEmployeeFormDialog />
        <AssignDepartmentDialog />
      </Box>
    );
  }

  return null;
};
